@let isMobile = breakpoints() === "mobile";
<section [id]="idComponent">
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <div class="container">
        @if (data.video[0]; as video) {
          <div class="video video-0">
            <ng-container
              *ngTemplateOutlet="
                videoTemplate;
                context: { video, width: isMobile ? '130px' : '325px', height: isMobile ? '160px' : '400px' }
              " />
          </div>
        }
        @if (data.video[1]; as video) {
          <div class="video video-1">
            <ng-container
              *ngTemplateOutlet="
                videoTemplate;
                context: { video, width: isMobile ? '100px' : '300px', height: isMobile ? '135px' : '405px' }
              " />
          </div>
        }
        @if (data.video[2]; as video) {
          <div class="video video-2">
            <ng-container
              *ngTemplateOutlet="
                videoTemplate;
                context: { video, width: isMobile ? '130px' : '325px', height: isMobile ? '170px' : '425px' }
              " />
          </div>
        }
        @if (data.video[3]; as video) {
          <div class="video video-3">
            <ng-container
              *ngTemplateOutlet="
                videoTemplate;
                context: { video, width: isMobile ? '150px' : '300px', height: isMobile ? '110px' : '220px' }
              " />
          </div>
        }
        <div class="content">
          <app-title [titles]="[title()]" class="title" />
        </div>
        <ng-template #videoTemplate let-height="height" let-video="video" let-width="width">
          <app-video
            [isHidePosterGoingFullscreen]="true"
            [isPlayFullscreen]="true"
            [isResetAfterFullscreen]="true"
            [mp4Url]="video.mp4Url"
            [previewImage]="video?.image"
            [style]="{ width, height }" />
        </ng-template>
      </div>
    </div>
  </div>
</section>
